import React from 'react';

import { List } from 'antd';

import { showDateNoTime } from '@libs/NwMoment';

import EmptyState from '@components/Gui/EmptyState';
import NwDrawer from '@components/Gui/NwDrawer';

const ExistingRoomLodging = ({ accommodations, onClose }) => {
    return (
        <NwDrawer title="Model's Room Lodgings" onClose={onClose}>
            {accommodations.length === 0 ? (
                <EmptyState message="No Room Lodging" />
            ) : (
                <List
                    itemLayout="horizontal"
                    dataSource={accommodations}
                    renderItem={(accommodation) => {
                        return (
                            <List.Item className="ant-list-item-top">
                                <List.Item.Meta
                                    title={`${accommodation.Room && accommodation.Room.Name}`}
                                    description={
                                        <>
                                            <div>
                                                {accommodation.Service ? accommodation.Service.Name : 'no service'}
                                            </div>
                                            <div>{`${showDateNoTime(accommodation.FromDate)} / ${showDateNoTime(accommodation.ToDate)}`}</div>
                                        </>
                                    }
                                />
                            </List.Item>
                        );
                    }}
                />
            )}
        </NwDrawer>
    );
};

export default ExistingRoomLodging;
